import { HTMLInputProps, NumericInputProps, NumericInput } from '@blueprintjs/core'
import React from 'react'

export interface NullSafeNumericInputProps extends NumericInputProps {
  //   Blueprint <NumericInput /> 2.32 (and above) rounds the initial value to the nearest minorStepSize step
  //     e.g.
  //     for minorStepSize 1:
  //     1.99 would round to 2
  //
  //     for minorStepSize 0.01:
  //     1.99 would stay as to 1.99

  minorStepSize: number
  preventNegative?: boolean
}

// NullSafeNumericInput
// - handles missing `value` prop gracefully
// - requires minorStepSize to prevent unexpected rounding
// - also prevents negative values if preventNegative is true
const NullSafeNumericInput: React.FC<NullSafeNumericInputProps & Omit<HTMLInputProps, 'size'>> = props => {
  const { preventNegative, ...numericInputProps } = props
  const nullSafeValue = [null, undefined].includes(numericInputProps.value) ? '' : numericInputProps.value
  const nullSafeProps = { ...numericInputProps, value: nullSafeValue }

  return (
    <NumericInput
      {...nullSafeProps}
      onInput={e => {
        if (preventNegative && !e.currentTarget.value.includes('e')) {
          e.currentTarget.value = e.currentTarget.value.replace(/[^0-9.]/g, '')
        }
        if (numericInputProps.onInput) {
          numericInputProps.onInput(e)
        }
      }}
    />
  )
}

export default NullSafeNumericInput
